<template>
  <div v-if="data" class="fixed bottom-0 left-0 z-[2]">
    <UiButton
      v-if="data.button && data.button.text"
      inverted
      size="xs"
      min-width="156px"
      inner-wrapper-class="shadow-[0_4px_24px_0_rgba(0,0,0,0.16)]"
      class="!absolute bottom-4 left-4 translate-y-0 transition-all duration-500"
      :class="[{ 'translate-y-[200%]': isOpen }]"
      @click="open"
    >
      {{ data.button.text }}
    </UiButton>

    <div
      v-if="data.popup"
      ref="popup"
      class="absolute bottom-4 left-4 translate-y-[200%] text-white transition-all duration-500"
      :class="[{ '!translate-y-0': isOpen }]"
    >
      <UiPopup
        v-model="isOpen"
        :image="data.popup.image"
        class="flex h-[200px] w-[235px] flex-col justify-end md:h-[280px] md:w-[400px]"
      >
        <div
          v-if="data.popup.text"
          class="title mb-4 whitespace-pre-line text-lg uppercase"
          v-text="data.popup.text"
        ></div>

        <UiButton
          v-if="data.popup.button && data.popup.button.link"
          inverted
          size="xs"
          min-width="156px"
          @click="bookMeeting"
        >
          {{ data.popup.button.text }}
        </UiButton>
      </UiPopup>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';
import { onClickOutside, useScroll } from '@vueuse/core';
import { useCookies } from '@vueuse/integrations/useCookies';
import { useOpenClose } from '~/composables';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { isOpen, open, close } = useOpenClose();
const popup = ref();
const cookies = useCookies(['book-meeting']);
const bmCookies = cookies.get('book-meeting') ?? {};

const setCookies = (key: string, value: any) => {
  cookies.set('book-meeting', { ...bmCookies, [key]: value });
};

const bookMeeting = () => {
  if (!bmCookies.isBooked) setCookies('isBooked', true);

  const { button } = props.data.popup;

  if (button?.link) window.open(button.link, button.target || '_blank');

  close();
};

const showPopupOnScroll = () => {
  const triggerEl = document?.getElementById('section-awards');
  if (!triggerEl) return;

  const { y } = useScroll(window);

  const unwatch = watch(y, (value) => {
    if (value < triggerEl?.offsetTop) return;

    setCookies('init', true);
    unwatch();
    open();
  });
};

onClickOutside(popup as any, () => close());

onMounted(() => {
  if (!bmCookies.init && !bmCookies.isBooked) showPopupOnScroll();
});
</script>
